declare const gon: {
    mutedUserIds?: string[]
    mutedQuestIds?: string[]
    mutedStreamIds?: string[]
    [key: string]: unknown
}

export function isUserMuted(userId: string): boolean {
    return gon.mutedUserIds?.includes(userId) || false
}

// Optional: Convert to Set for performance if mute list is large
let mutedUserSet: Set<string> | null = null

export function isUserMutedOptimized(userId: string): boolean {
    if (!mutedUserSet && gon.mutedUserIds) {
        mutedUserSet = new Set(gon.mutedUserIds)
    }
    return mutedUserSet?.has(userId) || false
}

// Clear the cached set when mute list updates
export function clearMutedUserCache(): void {
    mutedUserSet = null
}

// Add a user to the muted list (for dynamic updates)
export function addMutedUser(userId: string): void {
    if (gon.mutedUserIds) {
        if (!gon.mutedUserIds.includes(userId)) {
            gon.mutedUserIds = [...gon.mutedUserIds, userId]
            clearMutedUserCache()
        }
    } else {
        gon.mutedUserIds = [userId]
        clearMutedUserCache()
    }
}

// Remove a user from the muted list (for dynamic updates)
export function removeMutedUser(userId: string): void {
    if (gon.mutedUserIds) {
        gon.mutedUserIds = gon.mutedUserIds.filter(id => id !== userId)
        clearMutedUserCache()
    }
}

// Quest muting utilities (following user muting pattern)
export function isQuestMuted(questId: string): boolean {
    return gon.mutedQuestIds?.includes(questId) || false
}

// Optional: Convert to Set for performance if mute list is large
let mutedQuestSet: Set<string> | null = null

export function isQuestMutedOptimized(questId: string): boolean {
    if (!mutedQuestSet && gon.mutedQuestIds) {
        mutedQuestSet = new Set(gon.mutedQuestIds)
    }
    return mutedQuestSet?.has(questId) || false
}

// Clear the cached set when quest mute list updates
export function clearMutedQuestCache(): void {
    mutedQuestSet = null
}

// Add a quest to the muted list (for dynamic updates)
export function addMutedQuest(questId: string): void {
    if (gon.mutedQuestIds) {
        if (!gon.mutedQuestIds.includes(questId)) {
            gon.mutedQuestIds = [...gon.mutedQuestIds, questId]
            clearMutedQuestCache()
        }
    } else {
        gon.mutedQuestIds = [questId]
        clearMutedQuestCache()
    }
}

// Remove a quest from the muted list (for dynamic updates)
export function removeMutedQuest(questId: string): void {
    if (gon.mutedQuestIds) {
        gon.mutedQuestIds = gon.mutedQuestIds.filter(id => id !== questId)
        clearMutedQuestCache()
    }
}

// Stream muting utilities (following user/quest muting pattern)
export function isStreamMuted(streamId: string): boolean {
    return gon.mutedStreamIds?.includes(streamId) || false
}

// Add a stream to the muted list (for dynamic updates)
export function addMutedStream(streamId: string): void {
    if (gon.mutedStreamIds) {
        if (!gon.mutedStreamIds.includes(streamId)) {
            gon.mutedStreamIds = [...gon.mutedStreamIds, streamId]
        }
    } else {
        gon.mutedStreamIds = [streamId]
    }
}

// Remove a stream from the muted list (for dynamic updates)
export function removeMutedStream(streamId: string): void {
    if (gon.mutedStreamIds) {
        gon.mutedStreamIds = gon.mutedStreamIds.filter(id => id !== streamId)
    }
}
